/**
 * @generated SignedSource<<cab8335547dc0f2d350bd26c6a750645>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProjectArchiveMutation$variables = {
  id: number;
};
export type ProjectArchiveMutation$data = {
  readonly archiveProject: {
    readonly project: {
      readonly active: boolean;
      readonly id: number;
    } | null | undefined;
  };
};
export type ProjectArchiveMutation = {
  response: ProjectArchiveMutation$data;
  variables: ProjectArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ProjectResult",
    "kind": "LinkedField",
    "name": "archiveProject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "projects",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectArchiveMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectArchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a9b1efa3859acd4d4fd83e9f292fd7b0",
    "id": null,
    "metadata": {},
    "name": "ProjectArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectArchiveMutation(\n  $id: Int!\n) {\n  archiveProject(id: $id) {\n    project {\n      id\n      active\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7087bd54dbfd4b8c97036325236893b1";

export default node;
